export default "__VITE_ASSET__b270a0cc__"